/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  nights: 'nights',
  days: 'days',
  packagePriceInfo: 'packagePriceInfo',
  travelDates: 'travelDates',
  button: 'button',
  pricePerAdultFrom: 'pricePerAdultFrom'
}; export default Keys;